
<template lang="pug">
  div(v-if="showDespachos")
    h3 Despacho
      app-collapse(
        v-for="(conteudo, index) in despachos",
        :key="conteudo.id",
        :title="title"
        :collapsed="'1'"
      )
        b Responsável:
        p {{ conteudo.usuario.pessoa.pessoaFisica.nome }} ({{ capitalizarPalavra(conteudo.perfil) }})
        b Despacho:
        span(v-html="conteudo.textoDespacho")
        el-table(
          :data='conteudo.documentos',
          stripe
        )
          div(slot='empty')
            span Não há anexos disponíveis.
          el-table-column.td-column-anexo(
            prop='nome',
          )
          el-table-column.td-column-anexo(
            align="center",
            width="85"
          )
            template(slot-scope='scope')
              app-action-button(
                icone="download",
                nome="file_download",
                @click="baixarAnexo(scope.row)",
                hoverColor="#009f61",
                text="Baixar anexo"
              )

</template>

<script>
import AppCollapse from '@/components/AppCollapse'
import AppActionButton from '@/components/AppActionButton'

export default {

  props: {
    despachos: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },

  components: {
    AppCollapse,
    AppActionButton
  },

  computed: {
    showDespachos () {
      return this.despachos.filter(i => i.textoDespacho !== '').length > 0
    }
  },

  methods: {
    capitalizarPalavra (word) {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    },
    baixarAnexo (data) {
      this.$store.commit('loader/SET_LOADER')
      this.$store.dispatch('documentos/downloadDocumento', data.id)
        .then(() => {
          this.$store.commit('loader/RESET_LOADER')
        }).catch(() => {
          this.$store.commit('loader/RESET_LOADER')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AppDespachoSimplificado.vue